// extracted by mini-css-extract-plugin
export default {"container":"CustomLastStepTag_container__mqXPU","tag":"CustomLastStepTag_tag__qVk22","followup":"CustomLastStepTag_followup__PVxil","outreach":"CustomLastStepTag_outreach__Dh2wX"};